module.exports = __webpack_public_path__ + "img/rating-rang-3.9bd60923.svg";